import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { authedRoute } from '../../app/routes-base';

export const stokRoute = createRoute({
  getParentRoute: () => authedRoute,
  path: 'stok',
  component: lazyRouteComponent(() => import('./layout'), 'StokLayout'),
});

const stockRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: '/',
  component: lazyRouteComponent(() => import('./pages/stock-page'), 'StockPage'),
});

const valuationRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'valuasi',
  component: lazyRouteComponent(() => import('./pages/valuation-page'), 'ValuationPage'),
});

const movementsRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'mutasi',
  component: lazyRouteComponent(() => import('./pages/movements-page'), 'MovementsPage'),
});

const openingRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'saldo-awal',
  component: lazyRouteComponent(() => import('./pages/opening-balance-page'), 'OpeningBalancePage'),
});

const itemsRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'barang',
  component: lazyRouteComponent(() => import('./pages/items-page'), 'ItemsPage'),
});

const locationsRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'lokasi',
  component: lazyRouteComponent(() => import('./pages/locations-page'), 'LocationsPage'),
});

const lotsRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'lot',
  component: lazyRouteComponent(() => import('./pages/lots-page'), 'LotsPage'),
});

const lotRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'lot/$lotId',
  component: lazyRouteComponent(() => import('./pages/lot-page'), 'LotDetailPage'),
});

const receiptsRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'penerimaan',
  component: lazyRouteComponent(() => import('./pages/receipts-page'), 'ReceiptsPage'),
});

const receiptNewRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'penerimaan/baru',
  /** `?po=<purchase order id>` preselects the order to receive. */
  validateSearch: (search: Record<string, unknown>): { po?: string } =>
    typeof search.po === 'string' && search.po ? { po: search.po } : {},
  component: lazyRouteComponent(() => import('./pages/receipt-page'), 'ReceiptNewPage'),
});

const receiptRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'penerimaan/$receiptId',
  component: lazyRouteComponent(() => import('./pages/receipt-page'), 'ReceiptDetailPage'),
});

const purchaseOrdersRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'pesanan',
  component: lazyRouteComponent(() => import('./pages/purchase-orders-page'), 'PurchaseOrdersPage'),
});

const purchaseOrderNewRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'pesanan/baru',
  component: lazyRouteComponent(
    () => import('./pages/purchase-order-page'),
    'PurchaseOrderNewPage',
  ),
});

const purchaseOrderRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'pesanan/$poId',
  component: lazyRouteComponent(
    () => import('./pages/purchase-order-page'),
    'PurchaseOrderDetailPage',
  ),
});

const suppliersRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'pemasok',
  component: lazyRouteComponent(() => import('./pages/suppliers-page'), 'SuppliersPage'),
});

const wasteRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'waste',
  component: lazyRouteComponent(() => import('./pages/waste-page'), 'WastePage'),
});

const wasteNewRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'waste/baru',
  component: lazyRouteComponent(() => import('./pages/waste-record-page'), 'WasteNewPage'),
});

const wasteReportRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'waste/laporan',
  component: lazyRouteComponent(() => import('./pages/waste-report-page'), 'WasteReportPage'),
});

const wasteRecordRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'waste/$wasteId',
  component: lazyRouteComponent(() => import('./pages/waste-record-page'), 'WasteDetailPage'),
});

const countsRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'opname',
  component: lazyRouteComponent(() => import('./pages/counts-page'), 'CountsPage'),
});

const countNewRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'opname/baru',
  component: lazyRouteComponent(() => import('./pages/count-page'), 'CountNewPage'),
});

const countRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'opname/$countId',
  component: lazyRouteComponent(() => import('./pages/count-page'), 'CountDetailPage'),
});

const purchaseRequestsRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'permintaan',
  component: lazyRouteComponent(
    () => import('./pages/purchase-requests-page'),
    'PurchaseRequestsPage',
  ),
});

const purchaseRequestNewRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'permintaan/baru',
  component: lazyRouteComponent(
    () => import('./pages/purchase-request-page'),
    'PurchaseRequestNewPage',
  ),
});

const purchaseRequestRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'permintaan/$prId',
  component: lazyRouteComponent(
    () => import('./pages/purchase-request-page'),
    'PurchaseRequestDetailPage',
  ),
});

const transfersRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'transfer',
  component: lazyRouteComponent(() => import('./pages/transfers-page'), 'TransfersPage'),
});

const transferNewRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'transfer/baru',
  component: lazyRouteComponent(() => import('./pages/transfer-page'), 'TransferNewPage'),
});

const transferRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'transfer/$transferId',
  component: lazyRouteComponent(() => import('./pages/transfer-page'), 'TransferDetailPage'),
});

const consumptionRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'pemakaian',
  component: lazyRouteComponent(() => import('./pages/consumption-page'), 'ConsumptionPage'),
});

const supplierRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'pemasok/$supplierId',
  component: lazyRouteComponent(() => import('./pages/supplier-page'), 'SupplierDetailPage'),
});

const recallsRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'recall',
  component: lazyRouteComponent(() => import('./pages/recalls-page'), 'RecallsPage'),
});

const recallRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'recall/$caseId',
  component: lazyRouteComponent(() => import('./pages/recall-page'), 'RecallDetailPage'),
});

const countAccuracyRoute = createRoute({
  getParentRoute: () => stokRoute,
  path: 'opname/akurasi',
  component: lazyRouteComponent(() => import('./pages/count-accuracy-page'), 'CountAccuracyPage'),
});

export const stokTree = stokRoute.addChildren([
  stockRoute,
  valuationRoute,
  movementsRoute,
  openingRoute,
  itemsRoute,
  locationsRoute,
  lotsRoute,
  lotRoute,
  receiptsRoute,
  receiptNewRoute,
  receiptRoute,
  purchaseOrdersRoute,
  purchaseOrderNewRoute,
  purchaseOrderRoute,
  suppliersRoute,
  wasteRoute,
  wasteNewRoute,
  wasteReportRoute,
  wasteRecordRoute,
  countsRoute,
  countNewRoute,
  countRoute,
  purchaseRequestsRoute,
  purchaseRequestNewRoute,
  purchaseRequestRoute,
  transfersRoute,
  transferNewRoute,
  transferRoute,
  consumptionRoute,
  supplierRoute,
  recallsRoute,
  recallRoute,
  countAccuracyRoute,
]);
